'use client';

import { ServiceBase } from './ServiceBase';
import type { CurrentUser } from '../types/auth.types';
import { setCurrentToken } from '../utils/cookies';

/**
 * User service
 * Handles user-related API calls
 */
export class UserService extends ServiceBase {
  constructor() {
    super({
      endpoint: 'users',
    });
  }

  /**
   * Get current user (also verifies token)
   * Automatically sets token in ServiceBase and cookies
   * @param token - Access token
   * @returns Current user object
   */
  async getCurrentUser(token: string): Promise<CurrentUser> {
    if (token) {
      ServiceBase.setToken(token);
      setCurrentToken(token, 7); // 7 days expiry
      const response: any = await this.get({
        endpoint: 'currentUser',
        headers: {
          Authorization: token,
        },
        passthroughErrorCatcher: true,
      });

      // Flatten dbUser fields to top level for frontend compatibility
      return {
        ...response,
        ...response.dbUser, // Merge dbUser fields (including id) to top level
        _id: response.dbUser?._id || response.dbUser?.id,
      } as CurrentUser;
    }

    const response: any = await this.get({
      endpoint: 'currentUser',
    });

    // Flatten dbUser fields
    return {
      ...response,
      ...response.dbUser,
      _id: response.dbUser?._id || response.dbUser?.id,
    } as CurrentUser;
  }
}

export const userService = new UserService();
